import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

interface IProps {
  width?: number;
  height?: number;
}

function SezzleLogo(props: IProps) {
  const { width, height } = props;
  const altText = "Pay With Sezzle";
  return (
    <PAImage
      unoptimized
      width={width || 88}
      height={height || 21}
      src={getRelativeImagePath("/images/public/third-party/sezzle-logo.png")}
      alt={altText}
      title={altText}
    />
  );
}

export default SezzleLogo;
